import { useCallback, useEffect } from 'react';

export const useEscapeClose = (onClose: () => void, isActive: boolean) => {
  const handleEscape = useCallback(
    (e: KeyboardEvent) => {
      e.stopPropagation();

      if (e.key === 'Escape') {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    if (isActive) {
      document.addEventListener('keydown', handleEscape);

      return () => {
        document.removeEventListener('keydown', handleEscape);
      };
    }
  }, [isActive, handleEscape]);
};
